import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledCollectionSectionPanelHeader = styled(Box)`
  .CollectionSectionPanelHeader {
    &-head {
      display: flex;
      flex-direction: row;
      width: 100%;
      padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(3)} 0 ${props => props.theme.spacing(3)};
      align-items: center;
      gap: ${props => props.theme.layout('1sp')};
    }

    &-title {
      flex-grow: 1;
      width: 1px;
      
      > * {
        max-width: fit-content;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    
    &-buttons {
      display: flex;
      gap: ${props => props.theme.layout('1sp')};
    }
    
    &-info {
      margin: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(3)} 0 ${props => props.theme.spacing(3)};
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .CollectionSectionPanelHeader {
      &-head {
        padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)} 0 ${props => props.theme.spacing(2)};
      }
      &-info {
        margin: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)} 0 ${props => props.theme.spacing(2)};
      }
    }
  }
  ${ComponentStyles}
`;

StyledCollectionSectionPanelHeader.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionSectionPanelHeader;
